import type { Location } from "react-router";

export function getQueryStringValue(location: Location | undefined, queryStringParam: string): string | undefined {
  if (location && location.search) {
    const params = new URLSearchParams(location.search);
    return params.get(queryStringParam) || undefined;
  }
  return undefined;
}
